import './history-menu.css';

import { MenuItem } from 'primereact/menuitem';
import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';
import React from 'react';

import { LimitedEllipsisText } from '../../../../components/ui/LimitedEllipsisText';
import { getMapChangeDescription } from '../../../../utils/get-map-change-description';
import { NodeMapChange } from '../../use-mindmap-history';

export const getHistoryMenuModel = (
  changeHistory: NodeMapChange[],
  onItemClick: (index: number) => void,
  hoverState: [number, React.Dispatch<React.SetStateAction<number>>],
  dropdownMenuEndRef: React.RefObject<HTMLAnchorElement>,
) =>
  changeHistory.map((mapChange: NodeMapChange, index: number): MenuItem => {
    const [hoverIndex, setHoverIndex] = hoverState;
    const lastElementIndex = changeHistory.length - 1;

    return {
      template: (item, options) => {
        // get icon and descriptions of map changes
        const { icon, descriptions } = getMapChangeDescription(mapChange);

        // style menu item as hovering if this or a higher menu item is hovered over
        const showSelected = hoverIndex != -1 && index >= hoverIndex;

        // determine if this element is the last element to insert the dropdownMenuEndRef ref
        const isLastElement = lastElementIndex == index;

        const onMouseEnter = () => setHoverIndex(index);

        const onMouseLeave = () => setHoverIndex((index) => (index == index ? -1 : index));

        const onClick = () => onItemClick(index);

        const onTooltipIconClick = (e: React.MouseEvent<HTMLElement, MouseEvent>): void => {
          e.preventDefault();
          e.stopPropagation();
        };

        return (
          <a
            key={`history-menu-item-${index}`}
            className={classNames(options.className, showSelected ? 'menu-item-hovering' : '')}
            href="#"
            role="menuitem"
            target={item.target}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            ref={isLastElement ? dropdownMenuEndRef : undefined}
          >
            <span className={classNames(options.iconClassName, icon)}></span>
            <span className={classNames(options.labelClassName, 'flex-grow-1')}>
              {descriptions.map(({ text, preview, details }, yndex) => (
                <div
                  key={`history-menu-item-description-${index}-${yndex}`}
                  style={{ paddingBottom: yndex < descriptions.length - 1 ? 6 : 0 }}
                  className="flex justify-content-between align-content-center"
                >
                  <div className="flex-grow-1">
                    {text}
                    <br />
                    {preview && <LimitedEllipsisText maxWidth={412} textBlocks={preview} />}
                  </div>
                  {details && details.length > 0 && (
                    <div className="flex align-items-center justify-content-center">
                      <Tooltip
                        target={`.history-menu-item-description-tooltip-${index}-${yndex}`}
                        key={`.history-menu-item-description-tooltip-${index}-${yndex}`}
                        autoHide={false}
                        position="right"
                      >
                        <table className="history-table">
                          <tbody>
                            {details.map(({ value, name }) => (
                              <tr>
                                <td style={{ maxWidth: 600 * 0.382 }}>{name}</td>
                                <td style={{ maxWidth: 600 * 0.618 }}>{value}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Tooltip>
                      <i
                        onClick={onTooltipIconClick}
                        className={`history-menu-item-description-tooltip-${index}-${yndex} ri-information-line p-menuitem-icon`}
                        style={{ fontSize: '2rem', cursor: 'pointer', marginRight: 0 }}
                      ></i>
                    </div>
                  )}
                </div>
              ))}
            </span>
          </a>
        );
      },
    };
  });
